import { Mail, Phone } from "lucide-react";
import { fileUrl } from "@/lib/format";
import { useSiteSettings } from "@/lib/cms";
import { useDocumentTitle } from "@/lib/use-document-title";
import {
  DEFAULT_MAINTENANCE_MESSAGE,
  DEFAULT_MAINTENANCE_TITLE,
} from "@shared/maintenance";

/**
 * „Hamarosan" oldal — ez látszik a publikus útvonalak HELYETT, amíg a
 * „Hamarosan" mód aktív (admin → Oldal beállítások → Oldal állapota).
 *
 * Szándékosan nincs rajta menü, projekt-lista és semmilyen tartalmi elem: a
 * cél épp az, hogy a látogató NE lássa a javítás alatt álló tartalmat. Csak a
 * márka, a beállított szöveg és — ha az admin kéri — a közvetlen elérhetőség.
 */
export function ComingSoonPage() {
  const settings = useSiteSettings();
  const brand = settings.brand;
  const m = settings.maintenance ?? {};
  const title = (m.title || "").trim() || DEFAULT_MAINTENANCE_TITLE;
  const message = (m.message || "").trim() || DEFAULT_MAINTENANCE_MESSAGE;
  const showContact = m.showContact !== false;

  useDocumentTitle(title);

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6 py-16 text-center">
      {/* Márka */}
      <div className="flex flex-col items-center gap-4">
        {brand.logoImageKey ? (
          <img
            src={fileUrl(brand.logoImageKey)}
            alt={brand.shortName || brand.name}
            className="h-14 w-auto object-contain"
          />
        ) : (
          <div className="w-14 h-14 grid place-items-center font-heading font-bold text-2xl text-white bg-accent">
            {brand.logoLetter}
          </div>
        )}
        <div className="text-xs uppercase tracking-ultrawide font-semibold text-brand-500">
          {brand.name}
        </div>
      </div>

      <h1 className="mt-10 font-heading font-normal uppercase tracking-ultrawide text-brand-700 text-3xl sm:text-4xl lg:text-5xl">
        {title}
      </h1>

      <div className="mt-6 h-px w-16 bg-accent" aria-hidden="true" />

      <p className="mt-6 max-w-xl text-brand-600 leading-relaxed whitespace-pre-line">
        {message}
      </p>

      {showContact && (brand.phone || brand.email) && (
        <div className="mt-10 flex flex-col sm:flex-row items-center gap-4 sm:gap-8">
          {brand.phone && (
            <a
              href={`tel:${brand.phone.replace(/\s+/g, "")}`}
              className="inline-flex items-center gap-2 text-sm font-semibold text-brand-700 hover:text-accent transition-colors"
            >
              <Phone size={16} className="text-accent" />
              {brand.phone}
            </a>
          )}
          {brand.email && (
            <a
              href={`mailto:${brand.email}`}
              className="inline-flex items-center gap-2 text-sm font-semibold text-brand-700 hover:text-accent transition-colors"
            >
              <Mail size={16} className="text-accent" />
              {brand.email}
            </a>
          )}
        </div>
      )}

      <div className="mt-16 text-[10px] uppercase tracking-widish text-brand-400">
        © {brand.name} {new Date().getFullYear()}
      </div>
    </div>
  );
}
